// store/editorSlice.ts
import { createSlice } from '@reduxjs/toolkit';

const initialState: any = {
  elements: [],
  selectedId: null
};

export const editorSlice = createSlice({
  name: 'editor',
  initialState,
  reducers: {
    addTextElement: (state, action) => {
      state.elements.push(action.payload);
    },
    updateElement: (state, action) => {
      const { id, changes } = action.payload;
      const element = state.elements.find((el: any) => el.id === id);
      if (element) Object.assign(element, changes);
    },
    selectElement: (state, action) => {
      state.selectedId = action.payload;
    },




    addText: (state) => {
      // Dispatch add text on canvas
    },
    uploadImage: (state) => {
      // Upload image logic
    },
    exportDesign: (state) => {
      // Export only PrintArea logic
    },
  }
});

export const { addTextElement, updateElement, selectElement, addText, uploadImage, exportDesign } = editorSlice.actions;
export default editorSlice.reducer;
